module.exports = __webpack_public_path__ + "static/media/INDUSINDBK.64fb02bf.txt";